import { ZendeskCustomAccount } from './ZendeskTypes'

const ZendeskAccounts: {
    Production: ZendeskCustomAccount
    Sandbox: ZendeskCustomAccount
} = {
  Production: {
    domain: 'nexiasupport.zendesk.com',
    fields: {
      AUID: 114094536212,
      DEALER_BRAND: 360048704931,
      DEALER_NAME: 360048580352,
      BROWSER_TYPE: 40366462145165,
      PHONE: 360048654232,
      DEALER_CODE: 17192505702541,
      ROLE: 10053441295885,
      DEALER_TIER: 41050735156365,
      SUBSCRIPTION_TYPE: 41057682132621,
      USER_ID: 360048704991,
      DEALER_GUID: 41050557600269,
      DIAGNOSTICS_PRODUCT_CATEGORY: 1900002331047
    }
  },
  Sandbox: {
    domain: 'nexiasupport1560440782.zendesk.com',
    fields: {
      AUID: 360029971092,
      DEALER_BRAND: 360048080312,
      DEALER_NAME: 1900001744647,
      BROWSER_TYPE: 40366462145165,
      DEALER_CODE: 17163905996941,
      ROLE: 40365039151757,
      DEALER_TIER: 40366613978765,
      SUBSCRIPTION_TYPE: 40365714433293,
      USER_ID: 1900001744687,
      DEALER_GUID: 40365482570125,
      PHONE: 360030047351,
      DIAGNOSTICS_PRODUCT_CATEGORY: 1900001733347
    }
  }
}

export default ZendeskAccounts
